import {DocumentSourceType} from '@/constants/DoITConstant'

const truncateString = (string, lengthMax) => {
    if (string.length > lengthMax)
        return string.substring(0, lengthMax) + '...'
    else
        return string
}

const getHostName = (source) => {
    if (source.isGroup) {
        return 'Tài liệu trong nhóm'
    }
    let match = source.url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i)

    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2]
    } else {
        return 'Tài liệu nội bộ'
    }
}

const getDocumentSourceType = (source) => {
    const url = source.url
    if (url.startsWith('http') || url.startsWith('https'))
        return DocumentSourceType.WEB
    else if (source.isGroup)
        return DocumentSourceType.GROUP
    return DocumentSourceType.THESIS
}

const getStandardWord = (text) => {
    let ret = ''
    let i = -1
    while (++i < text.length) {
        let c = text[i]
        if (c.match(/^[0-9a-zA-Z ]+$/)) {
            ret += c
        }
    }
    return ret
}

const mark = (sen1, sen2) => {
    sen1 = getStandardWord(sen1).toLowerCase()
    const sen2Words = sen2.split(' ')
    let result = ''
    for (let word of sen2Words) {
        const standardWord = getStandardWord(word.toLowerCase())
        if (standardWord === '' || sen1.includes(standardWord)) {
            result = result + '<b>' + word + '</b> '
        } else {
            result = result + word + ' '
        }
    }
    return result.replaceAll('</b> <b>', ' ').replaceAll(/<b>(.{0,7})<\/b>/ig, "$1")
}

export {truncateString, getHostName, getDocumentSourceType, mark}
